import type { ComponentType } from 'react';
import React from 'react';
import { usePathParam, useQueryParam } from 'react-resource-router';
import { createContainer } from 'react-sweet-state';
import { getCloudId } from '@atlassian/help-center-common-util/meta';
import { useVirtualAgentConversationV2Provider } from '../../services/conversation-service';
import { ExternalSource } from '../../services/conversation-service/types';
import type { State } from './types';

export const ConversationStateContainer = createContainer<{
    conversationProvider: State['conversationProvider'];
    projectId?: State['projectId'];
    portalId?: State['portalId'];
    contextId?: State['contextId'];
    baseUrl?: State['baseUrl'];
    isTestConversation: State['isTestConversation'];
    handleEscalateFromVirtualAgent?: State['handleEscalateFromVirtualAgent'];
}>();

export const withConversationStateContainer = <TProps extends object>(WrappedComponent: ComponentType<TProps>) => {
    const WithRoutingStateContainer: React.FC<TProps & { contextId: string }> = (props) => {
        const { contextId } = props;
        const [isTestConversationParam] = useQueryParam('isTestConversation');
        const [portalId] = usePathParam('portalId');
        const isTestConversation = isTestConversationParam === 'true';

        const conversationProvider = useVirtualAgentConversationV2Provider({
            isTestConversation,
            contextId,
            cloudId: getCloudId(),
            externalSource: portalId ? ExternalSource.Portal : ExternalSource.Orchestrator,
        });

        return (
            <ConversationStateContainer
                conversationProvider={conversationProvider}
                contextId={contextId}
                isTestConversation={isTestConversation}
                isGlobal
            >
                <WrappedComponent {...props} />
            </ConversationStateContainer>
        );
    };

    return WithRoutingStateContainer;
};
